import React from "react";
import Header from "./page/layout/Header";
import TopBar from "./page/layout/TopBar";
import Home from "./page/Home/Home";
import Footer from "./page/layout/Footer";
import Copyright from "./page/layout/Copyright";
import Client from "./page/Home/Client";
import { Routes, Route } from "react-router-dom";
import About from "./page/Home/About";
import ITStaffing from "./page/Home/ITStaffing";
import Contact from "./page/Home/Contact";
import Technology from "./page/Home/Technology";

import Benefits from "./page/Home/Benefits";
import ReferralBonus from "./page/Home/ReferralBonus";

function App() {
  return (
    <div>
      {/* TopBar and Header are common components */}
      {/* <TopBar /> */}
      <Header />

      {/* Routing for different pages */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/client" element={<Client />} />
        <Route path="/about" element={<About />} />
        <Route path="/it-staffing" element={<ITStaffing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/technology" element={<Technology />} />

        <Route path="/benefits" element={<Benefits />} />
        <Route path="/referral-bonus" element={<ReferralBonus />} />
      </Routes>

      {/* Footer and Copyright */}
      <Footer />
      <Copyright />
    </div>
  );
}

export default App;
